// ===== COUNTDOWN TIMER =====
(function () {
  const widget = document.getElementById('husq-countdown');
  const d = widget ? parseInt(widget.dataset.days  || 2,  10) : 2;
  const h = widget ? parseInt(widget.dataset.hours || 18, 10) : 18;
  const m = widget ? parseInt(widget.dataset.mins  || 16, 10) : 16;
  const s = widget ? parseInt(widget.dataset.secs  || 34, 10) : 34;
  const totalSecs = (d * 86400) + (h * 3600) + (m * 60) + s;
  const STORAGE_KEY = 'husqSaleEndTime';
  const stored = localStorage.getItem(STORAGE_KEY);
  let endTime;
  if (stored && parseInt(stored) > Date.now()) {
    endTime = parseInt(stored);
  } else {
    endTime = Date.now() + totalSecs * 1000;
    localStorage.setItem(STORAGE_KEY, endTime.toString());
  }

  const elDays  = document.getElementById('cd-days');
  const elHours = document.getElementById('cd-hours');
  const elMins  = document.getElementById('cd-mins');
  const elSecs  = document.getElementById('cd-secs');

  // Guard: the countdown markup isn't present on every page/section instance.
  // Without this check, tick() below throws on elDays.textContent when
  // elDays is null, which aborts this whole script file and prevents the
  // mobile menu script further down from ever running.
  if (!elDays || !elHours || !elMins || !elSecs) return;

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const diff = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    elDays.textContent  = pad(Math.floor(diff / 86400));
    elHours.textContent = pad(Math.floor((diff % 86400) / 3600));
    elMins.textContent  = pad(Math.floor((diff % 3600) / 60));
    elSecs.textContent  = pad(diff % 60);
  }

  tick();
  setInterval(tick, 1000);
})();


// ===== MOBILE MENU =====
(function () {
  const hamburger  = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const closeBtn   = document.getElementById('mobile-close');

  let trapFocus;

  function openMenu() {
    if (mobileMenu.classList.contains('open')) return;
    mobileMenu.classList.add('open');
    document.body.style.overflow = 'hidden';
    hamburger.setAttribute('aria-expanded', 'true');

    const focusable = [...mobileMenu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    if (focusable.length) focusable[0].focus();

    trapFocus = function (e) {
      if (e.key !== 'Tab') return;
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    mobileMenu.addEventListener('keydown', trapFocus);
  }

  function closeMenu() {
    mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
    hamburger.setAttribute('aria-expanded', 'false');
    mobileMenu.removeEventListener('keydown', trapFocus);
    hamburger.focus();
  }

  hamburger.addEventListener('click', openMenu);
  closeBtn.addEventListener('click',  closeMenu);
  mobileMenu.addEventListener('click', function (e) { if (e.target === mobileMenu) closeMenu(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
})();


// ===== SEARCH ICON (desktop only) =====
(function () {
  const searchBtn = document.getElementById('search-btn-desktop');
  if (!searchBtn) return;

  function check() {
    searchBtn.style.display = window.innerWidth >= 1024 ? 'flex' : 'none';
  }

  // rAF-throttle: coalesces resize events to one paint cycle.
  // Reads innerWidth once per frame (not per pixel of drag), preventing
  // repeated forced reflows while the user is resizing the window.
  var rafId;
  function onResize() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      check();
    });
  }

  check();
  window.addEventListener('resize', onResize, { passive: true });
})();


// ===== DROPDOWN VIEWPORT COLLISION DETECTION =====
// When a nav dropdown (or its sub-dropdown) would extend past the right edge
// of the viewport, flip it so it opens in the opposite direction instead.
// Runs on both mouseenter (pointer) and focusin (keyboard) so both input
// modes get the correction.
(function () {
  var EDGE_MARGIN = 8; // px clearance from viewport edge

  function flipIfNeeded(dropdown, flipClass) {
    if (!dropdown) return;
    dropdown.classList.remove(flipClass);
    // rAF: the dropdown is visible at this point (hover/focus-within opened it),
    // so getBoundingClientRect gives accurate dimensions without forcing a reflow.
    requestAnimationFrame(function () {
      var rect = dropdown.getBoundingClientRect();
      if (rect.right > window.innerWidth - EDGE_MARGIN) {
        dropdown.classList.add(flipClass);
      }
    });
  }

  document.querySelectorAll('.nav-links .has-dropdown').forEach(function (item) {
    var topDropdown = item.querySelector(':scope > .nav-dropdown');
    ['mouseenter', 'focusin'].forEach(function (evt) {
      item.addEventListener(evt, function () {
        flipIfNeeded(topDropdown, 'nav-dropdown--flip');
      });
    });

    // Level-3: sub-dropdowns inside the top-level dropdown
    item.querySelectorAll('.has-dropdown').forEach(function (subItem) {
      var subDropdown = subItem.querySelector(':scope > .nav-dropdown--sub');
      ['mouseenter', 'focusin'].forEach(function (evt) {
        subItem.addEventListener(evt, function () {
          flipIfNeeded(subDropdown, 'nav-dropdown--sub-left');
        });
      });
    });
  });
})();


// ===== STICKY HEADER SCROLL STATE =====
// Two behaviours driven by a single scroll listener:
//  1. .is-stuck   → drop-shadow appears when page is scrolled (IntersectionObserver)
//  2. .header-hidden → header slides off-screen on scroll-down, returns on scroll-up
(function () {
  var header = document.getElementById('site-header');
  if (!header) return;

  // ── 1. Shadow via IntersectionObserver ──────────────────────────────────
  // An in-flow sentinel (no position:absolute) sits at the top of <main>.
  // When it exits the viewport the header is "stuck" — shadow appears.
  // No scroll listener needed = zero scroll-jank.
  var sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'width:0;height:1px;pointer-events:none;visibility:hidden;';
  // Insert sentinel as first child of <main> (or after the header wrapper)
  var main = document.querySelector('main') || document.getElementById('main-content');
  if (main) {
    main.insertBefore(sentinel, main.firstChild);
  } else {
    // fallback: place after header in DOM
    header.insertAdjacentElement('afterend', sentinel);
  }

  new IntersectionObserver(function (entries) {
    // When sentinel is NOT visible, header is stuck above the fold
    header.classList.toggle('is-stuck', !entries[0].isIntersecting);
  }, { threshold: 0 }).observe(sentinel);

  // ── 2. Hide/reveal on scroll direction ──────────────────────────────────
  var lastY = window.scrollY;
  var ticking = false;

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var delta = y - lastY;

      // Only hide after we've scrolled past the full header height
      if (y > header.offsetHeight) {
        if (delta > 0) {
          // Scrolling down → hide
          header.classList.add('header-hidden');
        } else if (delta < 0) {
          // Scrolling up → reveal
          header.classList.remove('header-hidden');
        }
      } else {
        // Near top — always show
        header.classList.remove('header-hidden');
      }

      lastY = y;
      ticking = false;
    });
  }, { passive: true });
})();


// ===== HEADER HEIGHT CSS VAR =====
// Exposes --header-height on :root so scroll-padding-top (CSS) and any JS
// that needs to offset from the sticky header always read the live value.
(function () {
  var header = document.getElementById('site-header');
  if (!header) return;

  function setHeaderHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      header.offsetHeight + 'px'
    );
  }

  // Set immediately (DOM is ready — this script is deferred / end-of-body)
  setHeaderHeight();

  // rAF-throttle on resize to avoid forced reflows per pixel of drag
  var rafId;
  window.addEventListener('resize', function () {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      setHeaderHeight();
    });
  }, { passive: true });
})();


// ===== NEWSLETTER FORM =====
(function () {
  const form = document.querySelector('.newsletter-form');
  if (!form) return;
  const input  = form.querySelector('input[type="email"]');
  const button = form.querySelector('.newsletter-btn');

  button.addEventListener('click', function () {
    if (!input.value || !input.checkValidity()) {
      input.classList.add('error');
      input.focus();
      return;
    }
    input.classList.remove('error');
    form.classList.add('is-subscribed');
  });

  input.addEventListener('input', function () {
    input.classList.remove('error');
  });
})();

